
import { WDFormBasic } from './wd-form-basic';
import WDButton from '../button/wd-button';

export class WDFormButton extends WDFormBasic {

  #value = null;
  #button = null;
  
  constructor(opts)
  {
  	const cfg = { 
  		theme: 'clear',
  		icon: 'fa-solid fa-edit',
  		handler: null,
  		value: null,
  		type: 'button',
  		templates: {
  			label: '${label}',
  			value: '${value}'
			},
		};
		
		//merge in the passed configs
		Object.assign(cfg,opts);
		
		const btn = new WDButton({label:'Not Selected',theme:cfg.theme});

    super(btn,cfg);
		this.#button = btn;
		
		if (cfg.icon) this.#button.icon(cfg.icon);
		if (cfg.handler) this.#button.on('click',cfg.handler);
		if (cfg.value && Object.keys(cfg.value).length > 0) this.val(cfg.value);

		if (cfg?.readonly) this.#button.disabled = true;
	};

	button() { return this.#button; };

	val(data)
	{
	  if (data === undefined)
	  {
	    return this.#value;
    }
    else
    {
    	//if templates.value is set to null, store the whole object
			this.#value = this.config().templates?.value !== null ? this.config().templates.value.interpolate(data) : data;

			const str = (data !== null) ? this.config().templates.label.interpolate(data) : 'Not Selected';

			this.#button.label(str);

			this.trigger('change');
			this.trigger('value:set');
		}

	};

};

customElements.define('wd-form-button',WDFormButton);
